
export default class FilterJobs {

  constructor ($el) {
    this.$el = $el;

    // Job elements.
    this.$jobs = $el.querySelectorAll('.module-filter__items > div');

    // Search field.
    this.$searchValue = '';
    this.$input = $el.querySelector('input.filter-search__input');
    this.$input.oninput = this.onInput.bind(this);

    // Checboxes.
    this.$filters = {
      'cities': [],
      'department': [],
      'entry-type': [],
    };
    this.$checkboxes = $el.querySelector('.module-filter__header');
    this.$checkboxes.addEventListener('click', this.onCheckboxClick.bind(this));
  }

  /**
   * Triggered on value change.
   */
  onInput (evt) {
    // Search for title.
    // The text search field is exclusive.
    // Meaning, after everything is filtered by checkboxes, we filter by text.
    this.$searchValue = this.$input.value.toUpperCase();

    this.updateJobsList();
  }

  onCheckboxClick (evt) {
    var input = evt.target.parentElement.querySelector('.filter-select__option-input');
    input.checked =! input.checked;

    var filterId = input.getAttribute('data-checkbox-filter');
    this.checkboxesUpdate(filterId);
  }

  checkboxesUpdate(filterId) {
    // Reset the values array to ensure no duplicates.
    this.$filters[filterId] = [];

    this.$checkboxes.querySelectorAll('.filter-checkbox--' + filterId + ' .filter-select__option').forEach(checkbox => {
      var input = checkbox.querySelector('.filter-select__option-input');
      var label = checkbox.querySelector('.filter-select__option-label').innerText;

      if (input.checked) {
        this.$filters[filterId].push(label.toLowerCase().trim().replace(/[^\w\s]/gi, ''));
      }
    });

    this.updateJobsList();
  }

  updateJobsList() {
    this.$jobs.forEach(job => {
      var showJob = true;

      if (this.$searchValue) {
        var headline = job.querySelector('.job-teaser__headline');
        var jobTitle = headline.innerText.toUpperCase();

        showJob = jobTitle.includes(this.$searchValue);
      }

      // No need to check if job is filtered out by the text search.
      if (showJob) {

        for(let filterId in this.$filters) {
          let filter = this.$filters[filterId];

          if (filter.length > 0) {
            if (filterId == 'cities') {
              // Get the current job's cities.
              const jobCities = job.querySelector('a').getAttribute('data-job-cities').split(",");
              console.log(jobCities);

              // Check if it intersects with the selection.
              const hasIntersection = filter.some(selectedCity =>
                jobCities.map(jobCity => jobCity.toLowerCase().trim().replace(/[^\w\s]/gi, '')).includes(selectedCity.toLowerCase())
              );

              if (!hasIntersection) {
                showJob = false;
                break;
              }
            }
            else {
              const jobValue = job.querySelector('a').getAttribute('data-job-' + filterId);

              if (!filter.includes(jobValue.toLowerCase().trim().replace(/[^\w\s]/gi, ''))) {
                showJob = false;
                break;
              }
            }
          }
        }
      }

      if (showJob) {
        job.classList.remove('job-teaser__hidden');
      }
      else {
        job.classList.add('job-teaser__hidden');
      }
    });
  }
}
